import React, { useState } from "react";
import moment from "moment";
import Countdown from "react-countdown";
import { useHistory } from "react-router";
import styled from "styled-components";
import { oAuth } from "../../../routes/basic/BasicAppRouter";
import { MobileSignIn } from "../../../pages/zipang/Header/ZipangHeader";
import auctions, { AuctionInvite } from "../../../services/ProductsApiService";

const StyledText = styled.span``;

const SubTimecontainer = styled.div`
  display: flex;
  gap: 10px;
`;
interface Iprops {
  product: any;
  prebidEndTime: any;
}

let seconds: any = "";

const ActionAuctionState = (props: Iprops) => {
  const [showSignIn, setShowSignIn] = useState(false);

  const handleSigninClose = () => {
    setShowSignIn(false);
    localStorage.removeItem("postLoginRedirect");
    // localStorage.setItem("sellerBtnClick", "false");
  };
  let { product, prebidEndTime } = props;
  let history = useHistory();
  const productTimeLeft = (items: any, isPrebidingTime: boolean) => {
    let { auctionStartDate } = items[0];
    let date: string | null = "";
    let time: string | null = "";
    let timezone: any = "";
    let startTime = isPrebidingTime ? prebidEndTime : auctionStartDate;

    if (startTime !== null || startTime !== undefined) {
      let previewTime = moment.utc(startTime);
      if (timezone !== null) {
        timezone = localStorage.getItem("timezoneName");
      }
      if (previewTime !== null && previewTime !== undefined) {
        let result = moment.tz(previewTime, timezone);
        let resultFormatter = result.format();

        if (resultFormatter !== "Invalid date") {
          let splitDateTime = resultFormatter.split("T", 2);
          let splitTime: any = "";

          if (splitDateTime[1].includes("+")) {
            splitTime = splitDateTime[1].split("+", 2);
          } else {
            splitTime = splitDateTime[1].split("-", 2);
          }

          date = splitDateTime[0];
          time = splitTime[0];
          let dateTime = `${date} ${time}`;
          let end: any = moment(dateTime);

          // Safely retrieve the user's timezone, or fall back to a default (e.g., 'UTC')
          timezone = localStorage.getItem("timezoneName") || "UTC";

          let start: any = moment(
            new Date().toLocaleString("en-US", { timeZone: timezone })
          );

          var timeDiff = end - start;
          seconds = Math.round(timeDiff);
        }
      }
    }
    return (
      <>
        {isPrebidingTime ? (
          <Countdown
            date={Date.now() + seconds}
            className="countdownText"
            renderer={prebidrenderer}
            zeroPadTime={2}
          />
        ) : (
          <Countdown
            date={Date.now() + seconds}
            className="countdownText"
            renderer={renderer}
            zeroPadTime={2}
          />
        )}
      </>
    );
  };

  const prebidrenderer = ({
    formatted: { days, hours, minutes, seconds },
    completed,
  }: any) => {
    if (completed) {
      if (
        days === "00" &&
        hours === "00" &&
        minutes === "00" &&
        seconds === "00"
      ) {
        return <span>Pre-bidding Locked</span>;
      }
    } else {
      return (
        <span>
          <StyledText>Prebidding Ends in:</StyledText> {days}:{hours}:{minutes}:
          {seconds}
        </span>
      );
    }
  };

  const renderer = ({
    formatted: { days, hours, minutes, seconds },
    completed,
  }: any) => {
    if (completed) {
      if (
        days === "00" &&
        hours === "00" &&
        minutes === "00" &&
        seconds === "00"
      ) {
        return <span>Live Bidding is Ongoing</span>;
      }
    } else {
      return (
        <span>
          {oAuth() ? (
            <>
              <StyledText>Live Bidding Starts in :</StyledText> {days}:{hours}:
              {minutes}:{seconds}
            </>
          ) : (
            <StyledText>Live bidding is about to start</StyledText>
          )}
        </span>
      );
    }
  };

  const returnAuctionStateWiseAction = (product: any) => {
    let { auctionState } = product[0];
    let actionRender: any;

    switch (auctionState) {
      case "NotStarted":
        if (oAuth()) {
          actionRender = productTimeLeft(product, true);
        } else {
          actionRender = "Prebidding has started";
        }
        break;
      case "Started":
        actionRender = (
          <>
            {oAuth() ? "Live bidding from here" : "Live bidding is ongoing"}
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={async () => {
                const auctionlist = await auctions();
                if (!auctionlist?.results || auctionlist.results.length === 0) {
                  return;
                }
                const {
                  auctionType,
                  id: auctionId,
                  auctionUserId,
                  name: auctionName,
                  startDate: auctionDate,
                  productCount: productCount,
                } = auctionlist.results[auctionlist.results.length - 1];
                if (oAuth()) {
                  const response = await AuctionInvite(auctionId);
                  let language = localStorage.getItem("language");
                  let languageCode =
                    language === "EN"
                      ? "en"
                      : language === "zh_CN"
                      ? "zh_CN"
                      : "jp";
                  localStorage.setItem("userId", response.data.auctionUserId);
                  history.push(
                    `/auction/details/${auctionId}/${auctionName}/${productCount}`
                  );
                } else {
                  let language = localStorage.getItem("language");
                  let languageCode =
                    language === "EN"
                      ? "en"
                      : language === "zh_CN"
                      ? "zh_CN"
                      : "jp";
                  const fullUrl =
                    window.location.origin +
                    `/${languageCode}/auction/details/${auctionId}/${auctionName}/${productCount}`;
                  localStorage.setItem("postLoginRedirect", fullUrl);
                  setShowSignIn(true);
                }
              }}
            >
              {" "}
              Link
            </span>
          </>
        );
        break;
      case "Paused":
        actionRender = "Auction is paused";
        break;
      case "Auction_Break":
        actionRender = (
          <>
            {oAuth() ? "Auction will resume in" : "Auction will resume soon. "}
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={async () => {
                const auctionlist = await auctions();
                if (!auctionlist?.results || auctionlist.results.length === 0) {
                  return;
                }
                const {
                  auctionType,
                  id: auctionId,
                  auctionUserId,
                  name: auctionName,
                  startDate: auctionDate,
                  productCount: productCount,
                } = auctionlist.results[auctionlist.results.length - 1];

                if (oAuth()) {
                  const response = await AuctionInvite(auctionId);
                  localStorage.setItem("userId", response.data.auctionUserId);
                  let language = localStorage.getItem("language");
                  let languageCode =
                    language === "EN"
                      ? "en"
                      : language === "zh_CN"
                      ? "zh_CN"
                      : "jp";
                  history.push(
                    `/auction/details/${auctionId}/${auctionName}/${productCount}`
                  );
                } else {
                  let language = localStorage.getItem("language");
                  let languageCode =
                    language === "EN"
                      ? "en"
                      : language === "zh_CN"
                      ? "zh_CN"
                      : "jp";
                  const fullUrl =
                    window.location.origin +
                    `/${languageCode}/auction/details/${auctionId}/${auctionName}/${productCount}`;
                  localStorage.setItem("postLoginRedirect", fullUrl);
                  setShowSignIn(true);
                }
              }}
            >
              Link
            </span>
          </>
        );
        break;
      case "Locked":
        if (oAuth()) {
          actionRender = productTimeLeft(product, false);
        } else {
          actionRender = "Live bidding is about to start";
        }
        break;
      default:
        actionRender = "";
        break;
    }
    return actionRender;
  };

  return (
    <>
      {props.product.length > 0 ? (
        <>
          <SubTimecontainer>
            {returnAuctionStateWiseAction(product)}
          </SubTimecontainer>
        </>
      ) : (
        <>{returnAuctionStateWiseAction(product)}</>
      )}
      <MobileSignIn show={showSignIn} onClose={handleSigninClose} />
    </>
  );
};

export default React.memo(ActionAuctionState);
